<div class="main-container-create">
    <div class="dialog-header">
        <div class="title-text">
            <span>Export</span> 
            Coupon Pool
        </div>
        <div class="flex align-items-center">
            <button class="primary-button button-hover-effect save-button" (click)="exportCouponPool()"> 
                <span>Export</span> 
            </button>
            <button class="primary-button secondary-button button-hover-effect" (click)="closedialog(false)">Close</button>
        </div>
    </div>

    <div class="main-content-container top-margin-standard">
        <div class="col-sm-6">
            <label class="main-label-style">Coupon Pool</label><span class="qb-imp-color">*</span>
            <div class="rp-name-inp-container">
                <mat-select [(ngModel)]="selectedCouponPoolId">
                    <mat-option *ngFor="let couponPool of data.couponPoolList" [value]="couponPool.id">{{couponPool.name}}</mat-option>
                </mat-select>
            </div>
        </div>
    
        <div class="col-sm-6">
            <label class="main-label-style">File type</label><span class="qb-imp-color">*</span>
            <div class="rp-name-inp-container">
                <mat-select [(ngModel)]="selectedFileType">
                    <mat-option [value]="'EXCEL'">Excel (.xlsx)</mat-option>
                    <mat-option [value]="'CSV'">CSV</mat-option>
                </mat-select>
            </div>
        </div>
    </div>
    
</div>